'use strict';

module.exports = isSame;

function isSame(other, units) {
    return this.isEqual(other, units);
}



// WEBPACK FOOTER //
// ./src/moment-wrange/lib/isSame.js